module.exports = __webpack_public_path__ + "static/warforged-1-457bbb89a78b167ee85cbd74f752c669.png";